import { useState } from 'react'
import { useRequests } from '../requests/useRequests'

export const useSearch = () => {
  const requests = useRequests()
  const [searchQuery, setSearchQuery] = useState<string>('')
  const [searchResults, setSearchResults] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const handleSearch = async (query: string = searchQuery) => {
    if (!query.trim()) {
      setSearchResults([])
      return
    }

    try {
      setLoading(true)
      const response = await requests.searchUsers(query)
      setSearchResults(response.data)
    } catch (err) {
      console.error('Błąd podczas wyszukiwania użytkowników:', err)
      setError('Nie udało się wyszukać użytkowników. Spróbuj ponownie później.')
    } finally {
      setLoading(false)
    }
  }

  return {
    searchQuery,
    setSearchQuery,
    searchResults,
    setSearchResults,
    loading,
    error,
    handleSearch
  }
}
